import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    CardItem,
    deepStringFind,
    formatDuration,
    inject,
    ModalHandle,
    StatusCard,
} from 'Mri.Web.Common';
import * as React from 'react';
import { Input } from 'reactstrap';
import { PartsStore } from '../../../Parts/PartsStore';
import { PartStatusModal } from '../../../Parts/PartStatusModal';
import { DisplayPartTreeItemCard } from '../../../Parts/PartsTree';
import { ActiveDisplay } from '../../ActiveDisplay';

export interface IDisplayPartsCardProps {
    readonly display: ActiveDisplay;
    readonly loading?: boolean;
}

@autoinject
@observer
export class DisplayPartsCard extends React.Component<IDisplayPartsCardProps> {
    public render() {
        return (
            <StatusCard title={this.renderTitle()} loading={this.props.loading}>
                <Input
                    type="text"
                    placeholder="Search Part..."
                    value={this.searchValue}
                    onChange={this.onSearchInputChange}
                    className="rounded-0 ticket-search"
                />
                {this.part && (
                    <div className="scroll-container">
                        <div className="scroll-card mt-2">
                            <div>
                                <DisplayPartTreeItemCard
                                    part={this.part}
                                    key={this.part.partGuid}
                                    searchValue={this.searchValue}
                                    showReplace={false}
                                    topLevelGuid={this.part.partGuid}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </StatusCard>
        );
    }

    @bind
    private renderTitle() {
        return (
            <div>
                Parts
                <a className="btn btn-primary float-end px-2" onClick={this.openStatusModal}>
                    Update Status
                </a>
                {this.part && (
                    <PartStatusModal
                        modalHandle={this.statusModalHandle}
                        partStatus={this.part.partStatus}
                        partGuid={this.part.partGuid}
                        includeChildren
                    />
                )}
            </div>
        );
    }

    @bind
    @action
    private onSearchInputChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        this.searchValue = target.value;
    }

    @bind
    private openStatusModal(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        this.statusModalHandle.open();
    }

    @computed
    private get topLevelGuid() {
        return this.props.display.unitPartGuid ?? this.props.display.partGuid;
    }

    @computed
    private get part() {
        return this.partsStore.parts.get(this.topLevelGuid);
    }

    @observable
    private searchValue: string = '';
    private statusModalHandle = new ModalHandle();
    @inject private partsStore!: PartsStore;
}
